import { Component, Input } from "@angular/core";
import { TypeManagerDecorator } from "../../../main/type.map.service";

@TypeManagerDecorator("s25-ng-generic-table-render-html")
@Component({
    selector: "s25-ng-generic-table-render-html",
    template: `
        @if (!isHtml) {
            <div class="preview-snippet">{{ text }}</div>
        }
        @if (isHtml) {
            <div class="preview-snippet" [innerHTML]="text | safeHTML"></div>
        }
    `,
    standalone: false,
})
export class GenericTableRenderHTMLComponent {
    @Input() text: string;
    @Input() isHtml: boolean;
}
